<template>
  <div id="simIndex" class="containerWarp">
    <!-- 筛选 -->
    <div style="margin-bottom:20px;display:flex;position:relative;">
      <el-input v-model="searchObj.iccId" placeholder="ICCID" class="input-with-select tableSelect" clearable @clear="changeSearch" style="width: 270px;">
        <el-button slot="append" icon="el-icon-search" @click="changeSearch" />
      </el-input>
      <el-input v-if="activeDevice=='sim2'" v-model="searchObj.mcuId" placeholder="MCUID" class="input-with-select tableSelect" clearable @clear="changeSearch">
        <el-button slot="append" icon="el-icon-search" @click="changeSearch" />
      </el-input>
      <el-input v-if="activeDevice=='sim1'" v-model="searchObj.yhubSn" :placeholder="$t('BondOrUpdateDevice.SN')" class="input-with-select tableSelect" clearable @clear="changeSearch">
        <el-button slot="append" icon="el-icon-search" @click="changeSearch" />
      </el-input>
      <el-select v-if="activeDevice!='sim3'" v-model="searchObj.companyId" :placeholder="$t('BondOrUpdateDevice.OwnedCompany')" class="filter-item tableSelect" clearable filterable @change="changeSearch">
        <el-option v-for="(item,index) in companyOptions" :key="index" :label="item.companyName" :value="item.companyId" />
      </el-select>
      <el-select v-if="activeDevice=='sim2'" v-model="searchObj.exceedFlow" :placeholder="$t('sim.DataUsage')" class="filter-item tableSelect" clearable filterable @change="changeSearch">
        <el-option v-for="(item,index) in exceedFlowOptions" :key="index" :label="item.label" :value="item.key" />
      </el-select>
      <!-- <el-select v-if="activeDevice=='sim1'" v-model="searchObj.status263" placeholder="263卡状态" class="filter-item tableSelect" clearable filterable @change="changeSearch">
        <el-option v-for="(item,index) in status263Options" :key="index" :label="item.label" :value="item.key" />
      </el-select> -->
      <el-select v-if="activeDevice=='sim1'" v-model="searchObj.status" :placeholder="$t('sim.CardStatus')" class="filter-item tableSelect" clearable filterable @change="changeSearch">
        <el-option v-for="(item,index) in statusOptions" :key="index" :label="item.label" :value="item.key" />
      </el-select>
      <div v-if="activeDevice=='sim2'" class="block tableSelect" style="margin-left:5px;">
        <el-date-picker v-model="searchObj.math" type="month" :placeholder="$t('sim.SelectMonth')" @change="changeSearch" />
      </div>
      <el-select v-if="activeDevice=='sim3'" v-model="searchObj.allStatus" :placeholder="$t('AllDevices.Status')" class="filter-item tableSelect" clearable filterable @change="changeSearch">
        <el-option v-for="(item,index) in statusAllOptions" :key="index" :label="item.label" :value="item.key" />
      </el-select>
      <el-select v-if="activeDevice=='sim2' || activeDevice=='sim3'" v-model="searchObj.type" :placeholder="$t('adminView.Type')" class="filter-item tableSelect" clearable filterable @change="changeSearch">
        <el-option v-for="(item,index) in typeOptions" :key="index" :label="item.label" :value="item.key" />
      </el-select>
      <div style="margin-top: 0px;position: absolute;right: 0;">
        <el-button v-if="activeDevice=='sim1'" icon="el-icon-upload2" style="padding: 6px 20px;font-size: 20px;" type="primary" @click="uploadExcel" />
        <el-button v-if="activeDevice!='sim3'" icon="el-icon-download" style="padding: 6px 20px;font-size: 20px;" type="primary" @click="downExcel" />
      </div>
      <!-- <el-button slot="append" icon="el-icon-download" @click="downExcel"/> -->
    </div>
    <el-tabs v-model="activeDevice" style="margin-top:15px;" type="border-card" class="simContentWarp">
      <!-- yhub -->
      <el-tab-pane v-if="false" :label="$t('sim.cardInfo')" name="sim1" style="position:relative;">
        <!-- 表格 -->
        <el-table id="feedBackTable" v-loading="loading1" :data="tableDataPan1" style="width: 100%" :default-sort="{prop: 'date', order: 'descending'}" border fit highlight-current-row>
          <el-table-column type="expand">
            <template slot-scope="scope">
              <el-form label-position="left" inline class="demo-table-expand">
                <el-col :xs="12" :sm="12" :lg="8">
                  <el-form-item label="MCUID">
                    <span>{{ scope.row.mcuId }}</span>
                  </el-form-item>
                </el-col>
                <el-col :xs="12" :sm="12" :lg="8">
                  <el-form-item :label="$t('AllDevices.Type')">
                    <span>{{ scope.row.type||'--' }}</span>
                  </el-form-item>
                </el-col>
                <el-col :xs="12" :sm="12" :lg="8">
                  <el-form-item :label="$t('sim.LatestMonths')">
                    <span>{{ scope.row.renewMonthZh }}</span>
                  </el-form-item>
                </el-col>
                <el-col :xs="12" :sm="12" :lg="8">
                  <el-form-item :label="$t('sim.SetMeal')">
                    <span>{{ scope.row.tcZh }}</span>
                  </el-form-item>
                </el-col>
                <el-col :xs="12" :sm="12" :lg="8">
                  <el-form-item :label="$t('sim.PackageFlow')">
                    <span>{{ scope.row.tcFlowZh }} M</span>
                  </el-form-item>
                </el-col>
                <el-col :xs="12" :sm="12" :lg="8">
                  <el-form-item :label="$t('sim.realFlow')">
                    <span>{{ scope.row.realFlowZh }}</span>
                  </el-form-item>
                </el-col>
                <el-col v-if="scope.row.exceedFlow<=0" :xs="12" :sm="12" :lg="8">
                  <el-form-item :label="$t('sim.RemainFlow')">
                    <span>{{ scope.row.exceedFlowZh }}</span>
                  </el-form-item>
                </el-col>
                <el-col v-if="scope.row.exceedFlow>0" :xs="12" :sm="12" :lg="8">
                  <el-form-item :label="$t('sim.Overflow')">
                    <span>{{ scope.row.exceedFlowZh }}</span>
                  </el-form-item>
                </el-col>
                <el-col :xs="12" :sm="12" :lg="8">
                  <el-form-item :label="$t('warningPage.Remark')">
                    <span>{{ scope.row.remarkZh }}</span>
                  </el-form-item>
                </el-col>
                <el-col :xs="12" :sm="12" :lg="8">
                  <el-form-item :label="$t('dashboard.LatestUpdate')">
                    <span>{{ scope.row.lastYhubTimeZh }}</span>
                  </el-form-item>
                </el-col>
              </el-form>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="yhubSn" label="yhubSn" align="center" /> -->
          <el-table-column prop="yhubSn" label="yhubSn" align="center">
            <template slot-scope="scope">
              <el-link v-if="scope.row. yhubSn" type="primary" @click="goToDetailPage(scope.row)">
                {{ scope.row. yhubSn }}
              </el-link>
              <p v-else>--</p>
            </template>
          </el-table-column>
          <el-table-column prop="iccId" label="ICCID" align="center" />
          <el-table-column prop="companyNameZh" :label="$t('BondOrUpdateDevice.OwnedCompany')" align="center" />
          <el-table-column prop="activeTimeZh" :label="$t('basicinfo.BindingTime')" align="center" />
          <el-table-column prop="giveMonthZh" :label="$t('sim.GiveMonth')" align="center" />
          <!-- <el-table-column prop="renewMonthZh" label="最新续费月数" align="center" /> -->
          <el-table-column prop="expireTimeZh" :label="$t('sim.Expiration')" align="center" />
          <!-- <el-table-column prop="status263Zh" label="263卡状态" align="center" /> -->
          <el-table-column prop="statuZh" :label="$t('sim.CardStatus')" align="center">
            <template slot-scope="scope">
              <div style="text-align: center;">
                <p :style="{color:scope.row.isOverTime?'red':''}">{{ scope.row.statuZh }}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column :prop="$t('yhubReport.Operating')" :label="$t('yhubReport.Operating')" align="center" width="300">
            <template slot-scope="scope">
              <div style="text-align: center;">
                <el-button v-if="!scope.row.activeTime" type="primary" size="mini" @click="edit(scope.row,'activation')">{{ $t('sim.activation') }}</el-button>
                <el-button v-if="scope.row.activeTime" type="primary" size="mini" @click="edit(scope.row,'renew')">{{ $t('sim.Renew') }}</el-button>
                <el-button v-if="scope.row.activeTime" type="primary" size="mini" @click="edit(scope.row,'repair')">{{ $t('sim.Repair') }}</el-button>
                <el-button v-if="scope.row.activeTime" type="primary" size="mini" @click="edit(scope.row,'scrap')">{{ $t('sim.scrapped') }}</el-button>
                <el-button v-if="scope.row.activeTime" type="primary" size="mini" @click="edit(scope.row,'reset')">{{ $t('sim.Reset') }}</el-button>
                <!-- <el-button type="primary" size="mini" icon="el-icon-edit" @click="edit(scope.row)" />
                <el-button type="primary" size="mini" icon="el-icon-refresh" @click="viewRow(scope.row)" /> -->
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- 列表模块————分页 -->
        <div style="background-color: white;width: 100%;border-radius: 0 0 10px 10px;">
          <div class="pagination-container">
            <el-pagination
              v-if="pageshow1"
              background
              current-page.sync="listQuery.pageInfo.page"
              :page-sizes="listQuery1.pageInfo.pageList"
              :page-size="listQuery1.pageInfo.limit"
              layout="total, sizes, prev, pager, next, jumper"
              :total="listQuery1.pageInfo.total"
              @size-change="handleSizeChange1"
              @current-change="handleCurrentChange1"
            />
          </div>
        </div>
      </el-tab-pane>

      <!-- SIM卡管理 -->
      <el-tab-pane :label="$t('sim.SIMMagt')" name="sim3" style="position:relative;">
        <!-- 表格 -->
        <el-table id="feedBackTable" v-loading="loading3" :data="tableData3" style="width: 100%" border fit>
          <el-table-column prop="iccId" width="190" label="ICCID" align="center" />
          <el-table-column prop="statuZh" :label="$t('AllDevices.Status')" align="center">
            <template slot-scope="scope">
              <p :class="'statuClass'+scope.row.statuId">{{ scope.row.statuZh }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="typeZh" :label="$t('adminView.Type')" align="center" />
          <el-table-column prop="realFlowZh" :label="$t('sim.realFlow')" align="center">
            <template slot-scope="scope">
              <p>{{ scope.row.realFlowZh }}</p>
              <p v-if="scope.row.type==4">{{ $t('sim.Total') }}{{ scope.row.realFlowTotal }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="tc" :label="$t('sim.PackageName')" align="center" show-overflow-tooltip >
            <template slot-scope="scope">
              <div class="tableCellHidePop">
                <span>{{ scope.row.tc }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="tc" :label="'设备SN'" align="center" >
            <template slot-scope="scope">
              <span>{{scope.row.deviceList.length? '':'--'}}</span>
              <span style="margin-right: 10px;" v-for="item in (scope.row.deviceList || [])">{{ item.deviceSn }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="countryCode" :label="$t('sim.AreaCode')" align="center" />
          <el-table-column prop="countryName" :label="$t('sim.AreaName')" align="center" /> -->
          <el-table-column prop="expiredTime" :label="'到期时间'" align="center" >
            <template slot-scope="scope">
              {{ getDateAndHour(scope.row.expiredTime, 'noTime') }}
            </template>
          </el-table-column>
          <el-table-column prop="iccId" :label="$t('yhubReport.Operating')" align="center">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" icon="el-icon-view" @click="openView(scope.row.iccId)" />
            </template>
          </el-table-column>
        </el-table>
        <!-- 列表模块————分页 -->
        <div style="background-color: white;width: 100%;border-radius: 0 0 10px 10px;">
          <div class="pagination-container">
            <el-pagination
              v-if="pageshow3"
              background
              current-page.sync="listQuery.pageInfo.page"
              :page-sizes="listQuery3.pageInfo.pageList"
              :page-size="listQuery3.pageInfo.limit"
              layout="total, sizes, prev, pager, next, jumper"
              :total="listQuery3.pageInfo.total"
              @size-change="handleSizeChange3"
              @current-change="handleCurrentChange3"
            />
          </div>
        </div>
      </el-tab-pane>

      <!-- SIM卡月报 -->
      <el-tab-pane :label="$t('sim.SIMMonthReport')" name="sim2" style="position:relative;">
        <!-- 表格 -->
        <el-table id="feedBackTable" v-loading="loading2" :data="tableData1" style="width: 100%" :default-sort="{prop: 'date', order: 'descending'}" border fit highlight-current-row>
          <el-table-column type="expand">
            <template slot-scope="scope">
              <el-form label-position="left" inline class="demo-table-expand">
                <el-col :xs="12" :sm="12" :lg="8">
                  <el-form-item :label="$t('sim.UseArea')">
                    <span>{{ scope.row.region }}</span>
                  </el-form-item>
                </el-col>
                <el-col :xs="12" :sm="12" :lg="8">
                  <el-form-item :label="$t('sim.Types')">
                    <span>{{ scope.row.typeZh }}</span>
                  </el-form-item>
                </el-col>
                <!-- <el-col :xs="12" :sm="12" :lg="8">
                  <el-form-item :label="$t('sim.SetMeal')">
                    <span>{{ scope.row.tc }}</span>
                  </el-form-item>
                </el-col> -->
                <!-- <el-col :xs="12" :sm="12" :lg="8">
                  <el-form-item :label="$t('sim.MonthlyTraffic')">
                    <span>{{ scope.row.tcFlowZh }} M</span>
                  </el-form-item>
                </el-col>
                <el-col :xs="12" :sm="12" :lg="8">
                  <el-form-item :label="$t('sim.realFlow')">
                    <span>{{ scope.row.realFlowZh }}</span>
                  </el-form-item>
                </el-col> -->
                <!-- <el-col v-if="scope.row.exceedFlow>0" :xs="12" :sm="12" :lg="8">
                  <el-form-item :label="$t('sim.RemainOverflow')">
                    <span>{{ scope.row.exceedFlowZh }}</span>
                  </el-form-item>
                </el-col> -->
              </el-form>
            </template>
          </el-table-column>
          <el-table-column prop="iccId" label="ICCID" align="center" />
          <el-table-column prop="mcuId" label="MCUID" align="center">
            <template slot-scope="scope">
              <el-link type="primary" @click="goToDeviceDetailPage(scope.row)">
                {{ scope.row. mcuId }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column prop="companyName" :label="$t('BondOrUpdateDevice.OwnedCompany')" align="center" />

          <!-- <el-table-column prop="region" label="使用地区" align="center" /> -->
          <!-- <el-table-column prop="typeZh" label="类型" align="center" /> -->
          <!-- <el-table-column prop="tc" label="套餐" align="center" /> -->
          <el-table-column prop="simType" :label="$t('adminView.Type')" align="center">
            <template slot-scope="scope">
              <div style="text-align: center;">
                <p v-if="scope.row.simType==1">263 {{ $t('sim.card') }}</p>
                <p v-if="scope.row.simType==2">keepgo {{ $t('sim.card') }}</p>
                <p v-if="scope.row.simType==3">datamobile {{ $t('sim.card') }}</p>
                <p v-if="scope.row.simType==4">truphone {{ $t('sim.card') }}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="monthZh" :label="$t('sim.month2')" align="center" />
          <el-table-column prop="tcFlowZh" :label="$t('sim.MonthlyTraffic')" align="center" />
          <el-table-column prop="realFlowZh" :label="$t('allDeviceDetail.realFlow')" align="center" />
          <!-- <el-table-column prop="exceedFlowZh" :label="$t('sim.RemainOverflow')" align="center" style="position:relative;" sortable>
            <template slot-scope="scope">
              <div style="justify-content: space-around;align-items: center;">
                <el-button v-if="scope.row.exceedFlow>0" size="mini" type="danger" plain style="padding: 1px 7px;position: absolute;top: 1px;left: 1px;">{{ $t('sim.ultra') }}</el-button>
                <el-button v-if="scope.row.exceedFlow<=0" size="mini" type="success" plain style="padding: 1px 7px;position: absolute;top: 1px;left: 1px;">{{ $t('sim.More') }}</el-button>
                <div v-if="scope.row.exceedFlow>0" style="text-align: center;" :style="{color:scope.row.exceedFlowZh>0?'red':'black'}">{{ scope.row.exceedFlowZh }}</div>
                <div v-if="scope.row.exceedFlow<=0" style="text-align: center;" :style="{color:scope.row.exceedFlowZh<0?'green':'black'}">{{ scope.row.exceedFlowZh }}</div>
              </div>
            </template>
          </el-table-column> -->
          <!-- <el-table-column prop="createTime" label="更新时间" align="center" /> -->
          <!-- <el-table-column prop="" :label="$t('yhubReport.Operating')" align="center">
            <template slot-scope="scope">
              <div style="text-align: center;">
                <el-button type="primary" size="mini" @click="viewRow(scope.row)">{{ $t('sim.latestData') }}</el-button>
              </div>
            </template>
          </el-table-column> -->
        </el-table>
        <!-- 列表模块————分页 -->
        <div style="background-color: white;width: 100%;border-radius: 0 0 10px 10px;">
          <div class="pagination-container">
            <el-pagination
              v-if="pageshow"
              background
              current-page.sync="listQuery.pageInfo.page"
              :page-sizes="listQuery.pageInfo.pageList"
              :page-size="listQuery.pageInfo.limit"
              layout="total, sizes, prev, pager, next, jumper"
              :total="listQuery.pageInfo.total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
          </div>
        </div>
      </el-tab-pane>

    </el-tabs>
    <!-- 查看最新信息--弹窗 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="isShowPop" :title="$t('sim.IoTCardInfo')+popDate" min-width="60%">
      <el-row class="tableWarp" style="margin-top: -20px;">
        <el-col :xs="24" :sm="24" :lg="24" class="card-panel-col">
          <!-- 列表 -->
          <div style="position: relative;width:100%;">
            <el-table :data="simData" style="width: 100%" border class="simTable">
              <el-table-column prop="name1" :label="$t('sim.Attributes')" align="center" class="simLabel" />
              <el-table-column prop="value1" :label="$t('sim.Value')" align="center" />
              <el-table-column prop="name2" :label="$t('sim.Attributes')" align="center" class="simLabel" />
              <el-table-column prop="value2" :label="$t('sim.Value')" align="center" />
            </el-table>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
    <!-- 编辑--弹窗 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="isShowEditPop" :title="editPopTitle" min-width="80%" class="editPop">
      <el-form ref="editPopForm" :inline="false" :model="editObj" :rules="editRules" label-position="right" label-width="150px">
        <el-row :gutter="40">
          <el-col :xs="24" :sm="24" :lg="12">
            <el-form-item label="ICCID" prop="">
              <el-input v-model="editObj.iccId" :disabled="true" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :lg="12">
            <el-form-item :label="$t('basicinfo.BindingTime')" prop="activeTime">
              <el-date-picker v-model="editObj.activeTime" :disabled="isDisabledActiveTime" type="date" @change="change($event)" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :lg="12">
            <el-form-item :label="$t('sim.GiveMonth')" prop="">
              <el-input-number v-model="editObj.giveMonth" :min="0" :disabled="isDisabledGiveMonth" :max="100" />
            </el-form-item>
          </el-col>
          <el-col v-if="activeBtn=='renew'" :xs="24" :sm="24" :lg="12">
            <el-form-item :label="$t('sim.RenewalMonth')" prop="">
              <el-input-number v-model="editObj.renewMonth" :disabled="isDisabledRenewMonth" :min="1" :max="100" />
            </el-form-item>
          </el-col>
          <!-- <el-col v-if="activeBtn!='activation'&&activeBtn!='renew'" :xs="24" :sm="24" :lg="12">
            <el-form-item label="最新续费月数" prop="">
              <el-input-number v-model="editObj.newRenewMonth" :disabled="isDisabledRenewMonth" :min="0" :max="100" label="描述文字" />
            </el-form-item>
          </el-col> -->
          <el-col :xs="24" :sm="24" :lg="12">
            <el-form-item :label="$t('sim.Expiration')" prop="">
              <el-input v-model="editObj.expireTimeZh" :disabled="true" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :lg="24">
            <el-form-item :label="$t('warningPage.Remark')" prop="mm">
              <el-input v-model="editObj.remark" :autosize="{ minRows: 4, maxRows: 8}" :placeholder="$t('warningSet.Pleaseenter')" style="width: 80%" type="textarea" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isShowEditPop = false">{{ $t('button.Cancel') }}</el-button>
        <el-button class="filter-item" type="primary" @click="submitEditPop('editPopForm')">{{ $t('button.Submit') }}</el-button>
      </div>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" :visible.sync="uploadFileDialog">
      <el-form label-position="left" label-width="130px" style="width: 400px; margin-left:50px;">
        <el-form-item label="File Name">
          <el-upload ref="upload" class="upload-demo" action="" :on-change="handleChange" :file-list="fileList" :auto-upload="false">
            <el-button slot="trigger" size="small" type="primary" :loading="uploading">{{ $t('sim.uploadFiles') }}</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="For Example">
          03006722.xls
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="uploadFileDialog = false">{{ $t('button.Cancel') }}</el-button>
        <el-button type="primary" @click="uploadFileSubmit">{{ $t('button.Submit') }}</el-button>
      </div>
    </el-dialog>

    <el-dialog :close-on-click-modal="true" class="statusPop" width="40%" :visible.sync="isShowDetail">
      <el-table v-loading.body="listLoading" :data="listSimStatisticsData" element-loading-text="Loading" style="height: 650px; overflow-y: auto;" border fit highlight-current-row>
        <el-table-column :label="$t('yhubReport.Date')" align="center" prop="monthStr" />
        <el-table-column :label="$t('allDeviceDetail.realFlow')" align="center" prop="realFlow">
          <template slot-scope="scope">
            <div style="text-align: center;">
              <p>{{ (scope.row.realFlow/1024).toFixed(2) }}M</p>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

  </div>
</template>

<script>
import { listByCompanyParentId } from '@/api/allDevice'
import { pagination } from '@/utils/init_table' // 分页
import { getMhxq } from '@/api/firmwareUpdate'
import { pageSim263Statistics, pageSim263Table, updateSim263Table, resetSim263Table, importUpdate, downLoadExcel, pageSimAllTable, listSimStatistics } from '@/api/sim'
import { getDateAndHour } from '@/utils/updateTime.js'
import { parseTime } from '@/utils'
import { arrObjSort } from '@/utils/arrayFun.js'
import vPinyin from '@/utils/pinyin-vue.js'



export default {
  name: 'DashboardAdmin',
  
  data() {
    return {
      getDateAndHour,
      tableData1: [],
      tableData3: [],
      // 分页----start
      listQuery: {
        deviceVersion: null,
        pageInfo: pagination(),
        q: ''
      },
      pageshow: true,
      // 分页----end
      tableDataPan1: [],
      // 分页----start
      listQuery1: {
        deviceVersion: null,
        pageInfo: pagination(),
        q: ''
      },
      pageshow1: true,
      // 分页----end
      // 分页----start
      listQuery3: {
        deviceVersion: null,
        pageInfo: pagination(),
        q: ''
      },
      pageshow3: true,
      // 分页----end
      isShowPop: false,
      popDate: '',
      simData: [],
      searchObj: {},
      companyOptions: [],
      activeDevice: 'sim3',
      isShowEditPop: false,
      editRules: {
        activeTime: [{ required: true, message: this.$t('lease.Cannotbeblanked'), trigger: 'blur' }]
      },
      editObj: {
        giveMonth: 0,
        renewMonth: 1,
        activeTime: null,
        remark: null
      },
      activeBtn: '',
      isShowStatuSelect: true,
      isDisabledActiveTime: false,
      isDisabledGiveMonth: false,
      isDisabledRenewMonth: false,
      editPopTitle: '',
      // 上传
      fileList: [],
      uploadFileDialog: false,
      uploading: false,
      value: 8,
      loading1: true,
      loading2: true,
      loading3: true,
      isShowDetail: false,
      listSimStatisticsData: [],
      listLoading: true
    }
  },
  computed: {
    language() {
      return this.$store.state.language
    },

    exceedFlowOptions() {
      return [
        { label: this.$t('sim.all'), key: 0 },
        { label: this.$t('sim.FlowExceeds'), key: 1 },
        { label: this.$t('sim.TrafficRemain'), key: 2 }
      ]
    },
    statusOptions() {
      return [
        { label: this.$t('sim.all'), key: -1 },
        { label: this.$t('sim.effective'), key: 1 },
        { label: this.$t('sim.Expired'), key: 2 },
        { label: this.$t('sim.Repair'), key: 3 },
        { label: this.$t('sim.scrapped'), key: 4 }
      ]
    },
    status263Options() {
      return [
        /* { label: this.$t('sim.beActivate'), key: ['1', '2', '4', '8', '512', '1024', '2048', '4096', 'Activation Ready', 'SUSPENDED'], id: '1' }, // 待激活
        { label: this.$t('sim.activated'), key: ['16', '8192', 'Activated', 'ACTIVE'], id: '2' }, // 已激活
        { label: this.$t('sim.Deactivate'), key: ['32', '64', '16384', 'Deactivated', 'TERMINATED'], id: '3' }, // 停用
        { label: this.$t('sim.cancellation'), key: ['128'], id: '4' },
        { label: this.$t('sim.Recycle'), key: ['256'], id: '5' },
        { label: this.$t('sim.pause'), key: ['Suspended'], id: '6' }*/

        { label: this.$t('sim.activated'), key: ['1'], id: '1' }, // 已激活
        { label: this.$t('sim.beActivate'), key: ['2'], id: '2' }, // 待激活
        { label: this.$t('sim.Deactivate'), key: ['3'], id: '3' } // 停用
      ]
    },
    statusAllOptions() {
      return [
        { label: this.$t('sim.all'), key: -1 },
        { label: this.$t('sim.activated'), key: 1 },
        { label: this.$t('sim.beActivate'), key: 2 },
        { label: this.$t('sim.Deactivate') + '/' + this.$t('sim.cancellation') + '/' + this.$t('sim.Recycle') + '/' + this.$t('sim.pause'), key: 3 }
      ]
    },
    typeOptions() {
      return [
        { label: this.$t('sim.all'), key: -1 },
        { label: '263' , key: 1 },
        { label: 'keepgo' , key: 2 },
        { label: 'datamobile' , key: 3 },
        { label: 'truphone' , key: 4 },
        { label: 'simboss' , key: 5 }
      ]
    }
  },
  watch: {
    language(newValue, oldValue) {
      this.queryList()
      this.queryListPan1()
      this.queryListPan3()
    },
    editObj: {
      handler(newValue, oldValue) {
        if (this.activeBtn == 'activation') { // 激活
          if (this.editObj.activeTime) { // 到期时间=激活时间+赠送月数
            this.editObj.expireTimeZh = this.getNewDate(this.editObj.activeTime, this.editObj.giveMonth)
          }
        } else if (this.activeBtn == 'renew') { // 续费
          if (this.editObj.expireTime) { // 到期时间=之前的到期时间+续费月数
            this.editObj.expireTimeZh = this.getNewDate(this.editObj.expireTime, this.editObj.renewMonth)
          }
        }
      },
      deep: true,
      immediate: false
    },
    activeDevice(newValue, oldValue) {
      if (newValue == 'sim1') this.queryListPan1()
      if (newValue == 'sim2') this.queryList()
      if (newValue == 'sim3') this.queryListPan3()
    }
  },
  created() {
    this.listByCompanyParentId()
  },
  mounted() {
    this.queryListPan3()
    // this.queryListPan1()
  },
  methods: {
    queryList() {
      var param = {
        pageNum: this.listQuery.pageInfo.pageNum, // 分页--选中某一页
        pageSize: this.listQuery.pageInfo.pageSize, // 分页--每一页的列表的行数 10 20 50
        exceed: '',
        companyIdList: [],
        iccId: this.searchObj.iccId || '',
        mcuId: this.searchObj.mcuId || '',
        month: new Date(this.searchObj.math).getTime() || '',
        simType: this.searchObj.type
      }
      switch (this.searchObj.exceedFlow) {
        case 0:param.exceed = ''; break
        case 1:param.exceed = true; break
        case 2:param.exceed = false; break
      }
      if (this.searchObj.companyId) {
        param.companyIdList.push(this.searchObj.companyId)
      }
      // param.exceed = this.searchObj.exceedFlow === 1
      this.loading2 = true
      pageSim263Statistics(param).then(res => {
        this.loading2 = false
        if (res.resultCode === 1001) {
          if (!res.resultModel) return
          var list = res.resultModel.list || []
          this.tableData1 = res.resultModel.list
          this.listQuery.pageInfo.total = res.resultModel.total // 分页
          if (list.length == 0) return
          list.forEach(v => {
            v.createTime = getDateAndHour(new Date(v.createTime).getTime(), 'noYear')
            v.typeZh = v.type === 2 ? this.$t('sim.CommercialCard') : this.$t('sim.TestCard')
            v.tcFlowZh = Math.round(v.tcFlow / 1024) + ' M'
            v.realFlowZh = (v.realFlow / 1024).toFixed(2) + ' M'
            if (v.exceedFlow < 0) {
              v.flowStatu = this.$t('sim.Remaining')
              if ((v.exceedFlow / 1024).toFixed(2) == 0) {
                v.exceedFlowZh = -v.exceedFlow + 'KB'
              } else {
                v.exceedFlowZh = (-v.exceedFlow / 1024).toFixed(2) + ' M'
              }
            } else {
              v.flowStatu = this.$t('sim.Beyond')
              if ((v.exceedFlow / 1024).toFixed(2) == 0) {
                v.exceedFlowZh = v.exceedFlow + 'KB'
              } else {
                v.exceedFlowZh = (v.exceedFlow / 1024).toFixed(2) + ' M'
              }
            }
            v.monthZh = getDateAndHour(v.month, 'onlyYearAndMonth')
          })
          this.tableData1 = list
        }
      })
    },
    queryListPan1() {
      var param = {
        pageNum: this.listQuery1.pageInfo.pageNum, // 分页--选中某一页
        pageSize: this.listQuery1.pageInfo.pageSize, // 分页--每一页的列表的行数 10 20 50
        exceed: null, // 当前是否超过流量，true/false
        // expire: null, // 卡使用期是否过期，true/false
        status: this.searchObj.status || -1, // 1有效，2.过期，3.送修状态，4.报废，-1全部
        companyIdList: [],
        iccId: this.searchObj.iccId || '',
        yhubSn: this.searchObj.yhubSn || '',
        status263: this.searchObj.status263 || []
      }
      // switch (this.searchObj.exceedFlow) {
      //   case 0:param.exceed = ''; break
      //   case 1:param.exceed = true; break
      //   case 2:param.exceed = false; break
      // }
      // switch (this.searchObj.expireFlow) {
      //   case 0:param.expire = null; break
      //   case 1:param.expire = true; break
      //   case 2:param.expire = false; break
      // }
      if (this.searchObj.companyId) {
        param.companyIdList.push(this.searchObj.companyId)
      }
      // param.exceed = this.searchObj.exceedFlow === 1
      this.loading1 = true
      pageSim263Table(param).then(res => {
        this.loading1 = false
        if (res.resultCode === 1001) {
          if (!res.resultModel) return
          this.tableDataPan1 = res.resultModel.list
          this.listQuery1.pageInfo.total = res.resultModel.total // 分页
          if (this.tableDataPan1.length == 0) return
          this.tableDataPan1.forEach((v, i) => {
            v.createTime = getDateAndHour(new Date(v.createTime).getTime(), 'noYear')
            v.activeTimeZh = v.activeTime ? getDateAndHour(new Date(v.activeTime).getTime(), 'noTime') : '--'
            v.tcFlowZh = Math.round(v.tcFlow / 1024)
            v.realFlowZh = (v.realFlow / 1024).toFixed(2) + ' M'
            v.isOverTime = false
            if (v.exceedFlow < 0 || !v.exceedFlow) {
              v.flowStatu = this.$t('sim.Remaining')
              if (!v.exceedFlow) {
                v.exceedFlowZh = '--'
              } else {
                if ((v.exceedFlow / 1024).toFixed(2) == 0) {
                  v.exceedFlowZh = -v.exceedFlow + 'KB'
                } else {
                  v.exceedFlowZh = (-v.exceedFlow / 1024).toFixed(2) + ' M'
                }
              }
            } else {
              v.flowStatu = this.$t('sim.Beyond')
              if ((v.exceedFlow / 1024).toFixed(2) == 0) {
                v.exceedFlowZh = v.exceedFlow + 'KB'
              } else {
                v.exceedFlowZh = (v.exceedFlow / 1024).toFixed(2) + ' M'
              }
            }
            v.renewMonthZh = v.renewMonth || v.renewMonth == 0 ? v.renewMonth : '--'
            v.expireTimeZh = v.expireTime ? getDateAndHour(new Date(v.expireTime).getTime(), 'onlyYearAndMonth') : '--'
            v.lastYhubTimeZh = v.lastYhubTime ? getDateAndHour(new Date(v.lastYhubTime).getTime(), 'noTime') : '--'
            v.companyNameZh = v.companyName ? v.companyName : '--'
            v.giveMonthZh = v.giveMonth || v.giveMonth == 0 ? v.giveMonth : '--'
            v.remarkZh = v.remark ? v.remark : '--'
            v.tcZh = v.tc ? v.tc : '--'
            // switch (v.status) {
            //   case 0:v.statuZh = '已过期'; break
            //   case 1:v.statuZh = '赠送期内'; break
            //   case 2:v.statuZh = '已经续费'; break
            //   case 3:v.statuZh = '送修状态'; break
            //   case 4:v.statuZh = '报废'; break
            //   default:v.statuZh = '--'
            // }
            if (!v.activeTime) {
              v.statuZh = '--'
            } else {
              if (v.status == 3) { // 送修
                v.statuZh = this.$t('sim.RepairStatus')
              } else if (v.status == 4) { // 报废
                v.statuZh = this.$t('sim.scrapped')
              } else if (v.status == 1) { // 有效
                v.statuZh = this.$t('sim.effective')
              } else if (v.status == 2) { // 过期
                v.statuZh = this.$t('sim.Expired')
                v.isOverTime = true
              }
            }
            this.status263Options.forEach(m => {
              if (m.key.indexOf(v.status263) > -1) {
                v.status263Zh = m.label
                v.status263Id = m.id
              }
            })
          })
          console.log(this.tableDataPan1)
        }
      })
    },
    queryListPan3() {
      var param = {
        pageNum: this.listQuery3.pageInfo.pageNum, // 分页--选中某一页
        pageSize: this.listQuery3.pageInfo.pageSize, // 分页--每一页的列表的行数 10 20 50
        status: this.searchObj.allStatus || -1, // 卡状态：1有效，2.待激活，3.异常状态（停用/销户/回收/暂停）， -1全部
        iccId: this.searchObj.iccId || '',
        type: this.searchObj.type || ''
      }
      // param.exceed = this.searchObj.exceedFlow === 1
      this.loading3 = true
      pageSimAllTable(param).then(res => {
        this.loading3 = false
        if (res.resultCode === 1001) {
          if (!res.resultModel) return
          this.tableData3 = res.resultModel.list
          this.listQuery3.pageInfo.total = res.resultModel.total // 分页
          if (this.tableData3.length == 0) return
          this.tableData3.forEach((v, i) => {
            v.tc = v.tc ? v.tc : '--'
            v.countryCode = v.countryCode ? v.countryCode : '--'
            v.countryName = v.countryName ? v.countryName : '--'
            // v.updateTimeZh = v.updateTime ? getDateAndHour(new Date(v.updateTime).getTime(), 'noTime') : '--'
            v.realFlowZh = (Number(v.realFlow) / 1024).toFixed(2) + ' M'
            this.typeOptions.forEach(m => {
              if (m.key == v.type)v.typeZh = m.label
            })
            v.statuZh = '--'
            this.status263Options.forEach(m => {
              if (m.key == v.status2) {
                v.statuZh = m.label
                v.statuId = m.id
              }
            })
            var obj = JSON.parse(v.jsonData) || {}
            v.realFlowTotal = (obj.realFlowTotal / 1024).toFixed(2) + ' M'
          })
        }
      })
    },
    viewRow(row) { // 查看最新消息弹窗--显示
      this.isShowPop = true
      getMhxq({ iccId: row.iccId }).then(res => {
        if (res.resultCode == 1001) {
          if (res.resultModel) {
            var obj = res.resultModel
            this.popDate = '  [ ' + this.$t('dashboard.LatestUpdate') + '： ' + getDateAndHour(new Date(obj.lastUpdateTime).getTime(), 'noSecond') + ' ]'
            if (obj.e == 1) { obj.e = this.$t('sim.notConnected') } else { obj.e = this.$t('sim.connected') }// 1：'未连接' 2：'已连接'
            if (obj.l == 1 || obj.l == 2 || obj.l == 4 || obj.l == 8 || obj.l == 512 || obj.l == 1024 || obj.l == 2048 || obj.l == 4096 || obj.l == 8192 || obj.l == 16384) {
              obj.l = this.$t('sim.beActivate')
            } else if (obj.l == 16) {
              obj.l = this.$t('sim.activated')
            } else if (obj.l == 32 || obj.l == 64) {
              obj.l = this.$t('sim.Deactivate')
            } else if (obj.l == 128) {
              obj.l = this.$t('sim.cancellation')
            } else if (obj.l == 256) {
              obj.l = this.$t('sim.Recycle')
            }
            this.simData = []
            if (res.resultModel.type == 'keepgo') {
              this.simData.push(
                { name1: this.$t('sim.PackageName'), key1: 'cb', value1: obj.rate_plan, name2: this.$t('sim.UsedTraffic'), key2: 'bs', value2: obj.monthly_usage_mb + 'M' },
              )
              return
            }
            this.simData.push(
              { name1: this.$t('sim.SimId'), key1: 'b', value1: obj.b, name2: this.$t('sim.SimICCID'), key2: 'ab', value2: obj.ab },
              { name1: this.$t('sim.GroupId'), key1: 'd', value1: obj.d, name2: this.$t('sim.groupName'), key2: 'eb', value2: obj.eb },
              { name1: this.$t('sim.PackageId'), key1: 'ba', value1: obj.ba, name2: this.$t('sim.PackageName'), key2: 'cb', value2: obj.cb },
              { name1: this.$t('sim.PackageFlow'), key1: 'br', value1: Math.round(obj.br / 1024) + 'M', name2: this.$t('sim.UsedTraffic'), key2: 'bs', value2: Math.round(obj.bs / 1024) + 'M' },
              { name1: this.$t('sim.ConnectionStatus'), key1: 'e', value1: obj.e, name2: this.$t('sim.NICstatus'), key2: 'l', value2: obj.l },
            )
          }
        }
      })
    },
    changeSearch(inputDevName) { // 筛选改变事件
      // 去掉首尾空格
      if (this.searchObj.iccId) this.searchObj.iccId = this.searchObj.iccId.replace(/(^\s*)|(\s*$)/g, '').replace(/(^\&nbsp\;*)|(\&nbsp\;*$)/g, '').replace(/(^\s*)|(\s*$)/g, '')
      if (this.searchObj.mcuId) this.searchObj.mcuId = this.searchObj.mcuId.replace(/(^\s*)|(\s*$)/g, '').replace(/(^\&nbsp\;*)|(\&nbsp\;*$)/g, '').replace(/(^\s*)|(\s*$)/g, '')
      if (this.searchObj.yhubSn) this.searchObj.yhubSn = this.searchObj.yhubSn.replace(/(^\s*)|(\s*$)/g, '').replace(/(^\&nbsp\;*)|(\&nbsp\;*$)/g, '').replace(/(^\s*)|(\s*$)/g, '')
      if (this.activeDevice == 'sim1') {
        this.listQuery1.pageInfo.pageNum = 1
        this.pageshow1 = false
        this.queryListPan1()
        this.$nextTick(() => {
          this.pageshow1 = true
        })
      } else if (this.activeDevice == 'sim2') {
        this.listQuery.pageInfo.pageNum = 1
        this.pageshow = false
        this.queryList()
        this.$nextTick(() => {
          this.pageshow = true
        })
      } else if (this.activeDevice == 'sim3') {
        this.listQuery3.pageInfo.pageNum = 1
        this.pageshow3 = false
        this.queryListPan3()
        this.$nextTick(() => {
          this.pageshow3 = true
        })
      }
    },
    listByCompanyParentId() { // 下拉框--客户名称
      listByCompanyParentId({
        companyParentId: this.$store.state.company.id
      }).then((response) => {
        if (response.resultCode == 1001) {
          this.companyOptions = []
          if (response.resultModel && response.resultModel.length > 1) {
            this.haveChildCompany = true
          } else {
            this.haveChildCompany = false
          }
          response.resultModel.forEach((v) => {
            if (v.companyName) {
              this.companyOptions.push({
                companyName: v.companyName,
                companyId: v.id
              })
            }
          })
          this.companyOptionsFun()
        }
      })
    },
    companyOptionsFun() { // 公司下拉框排序
      var sessionCompany = JSON.parse(sessionStorage.getItem('companyInfo'))
      // 将归属公司转拼音进行排序
      this.companyOptions.forEach((v) => {
        if (v.companyName[0] >= 'a' && v.companyName[0] <= 'z') {
          v.namePinyin = vPinyin.chineseToPinYin(v.companyName.toUpperCase())
        } else {
          v.namePinyin = vPinyin.chineseToPinYin(v.companyName)
        }
      })
      this.companyOptions.sort(arrObjSort('namePinyin'))
      var hadSelfCompany = false // 是否包含自己所在公司。因为受域名限制，可能不展示自己所在公司
      // 排序后，自己公司可能不在首位，所以先删除，再添加
      this.companyOptions.forEach((v, i) => {
        if (v.companyId == sessionCompany.id) {
          hadSelfCompany = true
          this.companyOptions.splice(i, 1)
        }
      })
      if (hadSelfCompany) {
        this.companyOptions.unshift({
          companyName: sessionCompany.companyName,
          companyId: sessionCompany.id
        })
      }
    },
    goToDetailPage(row) { // 去详情页
      var routeData = this.$router.resolve({
        path: '/sim/simDetail',
        query: {
          sn: row.yhubSn
        }
      })
      window.open(routeData.href, '_self')
      sessionStorage.setItem('simDetail', JSON.stringify(row))
    },
    goToDeviceDetailPage(row) { // 去设备详情页
      var routeData = this.$router.resolve({
        path: '/allDevices/allDeviceDetail',
        query: {
          deviceType: row.deviceType,
          mcuId: row.mcuId,
          sn: row.yhubSn
        }
      })
      window.open(routeData.href, '_self')
    },
    uploadExcel() { // 上传文件
      this.uploadFileDialog = true
    },
    handleChange(file, fileList) { // 上传弹窗
      this.fileList.push(file)
      this.$refs.upload.clearFiles()
    },
    uploadFileSubmit() { // 上传文件弹窗--提交
      this.uploading = true
      var file = this.fileList.pop()
      console.log('file--', file)
      importUpdate(file, this.value).then(response => {
        if (response.resultCode == 1001) {
          this.uploadFileDialog = false
          // this.list = response.list
          this.$notify({
            title: 'SUCCESS',
            message: 'Upload Success',
            type: 'success',
            duration: 2000
          })
          this.queryListPan1()
          this.uploading = false
        } else {
          this.$notify({
            title: 'ERROR',
            message: 'Upload error',
            type: 'error',
            duration: 2000
          })
          this.uploading = false
        }
      })
    },
    downExcel() { // 下载
      if (this.activeDevice == 'sim2') { // 前端下载
        import('@/vendor/Export2Excel').then(excel => {
          const tHeader = ['ICCID', 'MCUID', this.$t('sim.UseArea'), this.$t('sim.Types'), this.$t('sim.SetMeal'), this.$t('sim.month2'), this.$t('sim.realFlow'), this.$t('sim.DataUsage'), this.$t('sim.RemainOverflow')]
          const filterVal = ['iccId', 'mcuId', 'region', 'typeZh', 'tc', 'monthZh', 'realFlowZh', 'flowStatu', 'exceedFlowZh']
          const list = this.tableData1
          const data = this.formatJson(filterVal, list)
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: this.$t('sim.IoTCardInfo'), // '物联网卡信息',
            autoWidth: true,
            bookType: 'xlsx'
          })
        })
      } else { // 后台下载
        var param = {
          companyIdList: [],
          exceed: '', // 当前是否超过流量，true/false
          status: this.searchObj.status || -1, // 1有效，2.过期，3.送修状态，4.报废，-1全部
          iccId: this.searchObj.iccId || '',
          yhubSn: this.searchObj.yhubSn || '',
          pageNum: 1,
          pageSize: 10,
          status263: this.searchObj.status263 || []
        }
        switch (this.searchObj.exceedFlow) {
          case 0:param.exceed = ''; break
          case 1:param.exceed = true; break
          case 2:param.exceed = false; break
        }
        // switch (this.searchObj.expireFlow) {
        //   case 0:param.expire = ''; break
        //   case 1:param.expire = true; break
        //   case 2:param.expire = false; break
        // }
        if (this.searchObj.companyId) {
          param.companyIdList.push(this.searchObj.companyId)
        }
        downLoadExcel(param)
      }
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          if (j === 'timestamp') {
            return parseTime(v[j])
          } else {
            return v[j]
          }
        })
      )
    },
    edit(row, val) { // 编辑弹窗--显示
      this.isShowEditPop = true
      this.activeBtn = val
      for (var attr in this.editObj) this.editObj[attr] = ''
      this.editObj.iccId = row.iccId
      this.isDisabledActiveTime = this.isDisabledGiveMonth = this.isDisabledRenewMonth = true
      // 赋值
      if (val == 'renew' || val == 'repair' || val == 'scrap' || val == 'reset') { // 续费/报修
        this.editObj.activeTime = row.activeTime
        this.editObj.expireTime = row.expireTime
        this.editObj.giveMonth = row.giveMonth
        this.editObj.renewMonth = row.renewMonth
        this.editObj.newRenewMonth = row.renewMonth
        this.editObj.expireTimeZh = getDateAndHour(row.expireTime, 'onlyYearAndMonth')
        this.editObj.num = 1
      }
      if (val == 'activation') { // 激活
        this.editPopTitle = this.$t('sim.activation')
        this.isDisabledActiveTime = this.isDisabledGiveMonth = false // 激活时间是否可编辑
      } else if (val == 'renew') { // 续费
        this.editPopTitle = this.$t('sim.Renew')
        this.isDisabledRenewMonth = false // 续费月数是否可编辑
      } else if (val == 'repair') { // 报修
        this.editPopTitle = this.$t('sim.Repair')
      } else if (val == 'scrap') { // 报废
        this.editPopTitle = this.$t('sim.scrapped')
      } else if (val == 'reset') { // 重置
        this.editPopTitle = this.$t('sim.Reset')
      }
    },
    submitEditPop(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.editObj.activeTime) {
            this.$message({
              type: 'error',
              message: this.$t('sim.selectDate')// '请选择激活日期！'
            })
            return
          }
          var param = {}
          if (this.activeBtn == 'activation') { // 激活
            param = {
              'activeTime': new Date(this.editObj.activeTime).getTime(), // 激活
              'expireTime': new Date(this.editObj.expireTimeZh).getTime(), // 过期
              'giveMonth': this.editObj.giveMonth, // 赠送月份
              'iccId': this.editObj.iccId,
              'remark': this.editObj.remark,
              'status': 1
            }
          } else if (this.activeBtn == 'renew') { // 续费
            param = {
              'expireTime': new Date(this.editObj.expireTimeZh).getTime(), // 过期
              'renewMonth': this.editObj.renewMonth, // 续费月份
              'iccId': this.editObj.iccId,
              'remark': this.editObj.remark,
              'status': 1
            }
          } else if (this.activeBtn == 'repair') { // 报修
            param = {
              'iccId': this.editObj.iccId,
              'remark': this.editObj.remark,
              'status': 3
            }
          } else if (this.activeBtn == 'scrap') { // 报废
            param = {
              'iccId': this.editObj.iccId,
              'remark': this.editObj.remark,
              'status': 4
            }
          }
          if (this.activeBtn == 'activation' || this.activeBtn == 'renew' || this.activeBtn == 'repair' || this.activeBtn == 'scrap') {
            updateSim263Table(param).then(res => {
              if (res.resultCode == 1001) {
                this.isShowEditPop = false
                this.$message({
                  type: 'success',
                  message: this.$t('warningSet.submitted')
                })
                this.queryListPan1()
              }
            })
          } else if (this.activeBtn == 'reset') {
            param = {
              'activeTime': '', // 激活
              'expireTime': '', // 过期
              'giveMonth': '', // 赠送月份
              'iccId': this.editObj.iccId,
              'remark': ''
            }
            resetSim263Table(param).then(res => {
              if (res.resultCode == 1001) {
                this.isShowEditPop = false
                this.$message({
                  type: 'success',
                  message: this.$t('warningSet.submitted')
                })
                this.queryListPan1()
              }
            })
          }
        }
      })
    },
    changeStatus() {

    },
    change(e) {
      this.$forceUpdate()
    },
    getNewDate(time, addMonth) { // time:时间戳  addMonth:增加的月数
      var year = new Date(time).getFullYear()
      var month = new Date(time).getMonth() + 1 < 10 ? (new Date(time).getMonth() + 1) : new Date(time).getMonth() + 1
      var totalMonth = month + addMonth
      var newDate = 0
      if (totalMonth <= 12) {
        newDate = year + '/' + totalMonth
      } else if (totalMonth % 12 == 0) {
        newDate = year + Math.floor(totalMonth / 12) - 1 + '/' + 12
      } else {
        newDate = year + Math.floor(totalMonth / 12) + '/' + totalMonth % 12
      }
      return newDate
    },
    openView(iccId) {
      // console.log(iccId)
      this.listSimStatisticsData = []
      this.isShowDetail = this.listLoading = true
      listSimStatistics(iccId).then(res => {
        this.listLoading = false
        if (res.resultCode == 1001) {
          this.listSimStatisticsData = res.resultModel
          this.listSimStatisticsData.forEach((v) => {
            v.monthStr = getDateAndHour(v.month, 'onlyYearAndMonth')
          })
        }
      })
    },
    // 分页----start
    handleSizeChange(val, e) { // 每一页的列表的行数 10 20 50
      this.listQuery.pageInfo.pageSize = val
      this.queryList()
    },
    handleCurrentChange(val, e) { // 选中某一页
      this.listQuery.pageInfo.pageNum = val
      this.queryList()
    },
    // 分页----end
    // 分页----start
    handleSizeChange1(val, e) { // 每一页的列表的行数 10 20 50
      this.listQuery1.pageInfo.pageSize = val
      this.queryListPan1()
    },
    handleCurrentChange1(val, e) { // 选中某一页
      this.listQuery1.pageInfo.pageNum = val
      this.queryListPan1()
    },
    // 分页----end
    // 分页----start
    handleSizeChange3(val, e) { // 每一页的列表的行数 10 20 50
      this.listQuery3.pageInfo.pageSize = val
      this.queryListPan3()
    },
    handleCurrentChange3(val, e) { // 选中某一页
      this.listQuery3.pageInfo.pageNum = val
      this.queryListPan3()
    }
    // 分页----end
  }
}
</script>

<style lang="scss">
#simIndex{
  .simTable{
    th:nth-of-type(odd),td:nth-of-type(odd){
      background: #f0f2f591;
    }
  }
  .tableSelect{
    width:16%;
    max-width:400px;
    vertical-align: top;
  }
  .el-date-editor.el-input{
    width: 100%;
  }
  .simContentWarp .el-form-item {
    margin-bottom: 0;
  }
  .editPop{
    .el-input-number--medium,.el-form-item--medium,.el-select {
      width: 100%!important;
    }
  }
  .statuClass2{
    color:#1890ff;
  }
  .statuClass1{
    color:green;
  }
  .statuClass3{
    color:red;
  }
}
</style>
